import React from "react";
import { Helmet } from "react-helmet-async";
import { Link } from "react-router-dom";

const ContactPage = () => {
  const contactInfo = [
    {
      icon: "fas fa-map-marker-alt",
      title: "ที่อยู่",
      details: [
        "319 ถนนไทยพันทา",
        "ตำบลโพธิ์ อำเภอเมือง",
        "จังหวัดศรีสะเกษ 33000",
      ],
      color: "text-red-500",
    },
    {
      icon: "fas fa-phone-alt",
      title: "โทรศัพท์",
      details: ["045-564-362-2"],
      color: "text-green-500",
    },
    {
      icon: "fas fa-envelope",
      title: "อีเมล์",
      details: ["lifelong@sskru.ac.th"],
      color: "text-blue-500",
    },
    {
      icon: "fas fa-clock",
      title: "เวลาทำการ",
      details: [
        "วันจันทร์ - ศุกร์",
        "08:30 - 16:30 น.",
        "(หยุดวันเสาร์-อาทิตย์ และวันหยุดนักขัตฤกษ์)",
      ],
      color: "text-secondary-500",
    },
  ];

  const socialLinks = [
    {
      icon: "fab fa-facebook-f",
      url: "https://www.facebook.com/profile.php?id=100067890830799",
      label: "Facebook",
      color: "bg-[#1877f2]",
    },
    {
      icon: "fab fa-youtube",
      url: "https://www.youtube.com/@SSKRU-knowledge",
      label: "YouTube",
      color: "bg-[#ff0000]",
    },
  ];

  return (
    <>
      <Helmet>
        <title>ติดต่อเรา | งานบริการวิชาการ มหาวิทยาลัยราชภัฏศรีสะเกษ</title>
        <meta
          name="description"
          content="ติดต่องานบริการวิชาการ สำนักส่งเสริมวิชาการและจัดการเรียนรู้ตลอดชีวิต มหาวิทยาลัยราชภัฏศรีสะเกษ"
        />
      </Helmet>

      <div className="min-h-screen bg-gradient-to-br from-primary-50 to-blue-50 py-12">
        <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
          {/* Page Header */}
          <div className="text-center mb-12">
            <div className="inline-block p-4 bg-primary-100 rounded-full mb-4">
              <i className="fas fa-envelope text-3xl text-primary-500"></i>
            </div>
            <h1 className="text-4xl md:text-5xl font-bold text-primary-500 mb-4 relative inline-block pb-4 after:content-[''] after:absolute after:bottom-0 after:left-1/2 after:-translate-x-1/2 after:w-24 after:h-1 after:bg-secondary-500 after:rounded-full">
              ติดต่อเรา
            </h1>
            <p className="text-gray-600 max-w-2xl mx-auto">
              ติดต่อสอบถามข้อมูลเพิ่มเติม หรือปรึกษางานบริการวิชาการ
              ทีมงานของเรายินดีให้บริการ
            </p>
          </div>

          {/* Contact Info Grid */}
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-12">
            {contactInfo.map((info, index) => (
              <div
                key={index}
                className="bg-white rounded-xl shadow-lg p-6 hover:shadow-xl transition-all hover:-translate-y-2 group"
              >
                <div
                  className={`text-3xl ${info.color} mb-4 group-hover:scale-110 transition-transform`}
                >
                  <i className={info.icon}></i>
                </div>
                <h3 className="text-lg font-semibold text-gray-800 mb-2">
                  {info.title}
                </h3>
                {info.details.map((detail, i) => (
                  <p key={i} className="text-gray-600">
                    {detail}
                  </p>
                ))}
              </div>
            ))}
          </div>

          {/* Map and Social Section */}
          <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
            {/* Map */}
            <div className="lg:col-span-2">
              <div className="bg-white rounded-xl shadow-lg p-6">
                <h2 className="text-2xl font-semibold text-primary-500 mb-4 flex items-center">
                  <i className="fas fa-map-marked-alt text-secondary-500 mr-2"></i>
                  แผนที่ตั้ง
                </h2>
                <div className="relative rounded-lg overflow-hidden shadow-inner">
                  <iframe
                    title="แผนที่มหาวิทยาลัยราชภัฏศรีสะเกษ"
                    src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3851.763121584131!2d104.35701737511627!3d15.116378485433431!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3116e347666463c3%3A0xc6a986d7ba1e6f95!2z4Lih4Lir4Liy4Lin4Li04LiX4Lii4Liy4Lil4Lix4Lii4Lij4Liy4LiK4Lig4Lix4LiO4Lio4Lij4Li14Liq4Liw4LmA4LiB4Lip!5e0!3m2!1sth!2sth!4v1771865902360!5m2!1sth!2sth"
                    width="100%"
                    height="400"
                    style={{ border: 0 }}
                    allowFullScreen=""
                    loading="lazy"
                    className="w-full"
                  ></iframe>
                </div>
              </div>
            </div>

            {/* Social & Quick Contact */}
            <div className="lg:col-span-1">
              <div className="bg-white rounded-xl shadow-lg p-6">
                <h2 className="text-2xl font-semibold text-primary-500 mb-4 flex items-center">
                  <i className="fas fa-share-alt text-primary-500 mr-2"></i>
                  ติดตามเรา
                </h2>

                {/* Social Links */}
                <div className="space-y-3 mb-6">
                  {socialLinks.map((social, index) => (
                    <a
                      key={index}
                      href={social.url}
                      target="_blank"
                      rel="noopener noreferrer"
                      className={`flex items-center gap-3 p-3 rounded-lg text-white ${social.color} hover:opacity-90 transition-opacity`}
                    >
                      <i className={`${social.icon} text-xl`}></i>
                      <span>{social.label}</span>
                      <i className="fas fa-external-link-alt ml-auto text-sm"></i>
                    </a>
                  ))}
                </div>

                {/* Quick Contact */}
                <div className="border-t pt-6">
                  <h3 className="font-semibold text-gray-800 mb-3">
                    ติดต่อด่วน
                  </h3>
                  <div className="space-y-2">
                    <a
                      href="tel:0455643622"
                      className="flex items-center gap-2 p-2 hover:bg-gray-50 rounded-lg transition-colors"
                    >
                      <div className="w-8 h-8 bg-green-100 rounded-full flex items-center justify-center text-green-600">
                        <i className="fas fa-phone"></i>
                      </div>
                      <div>
                        <div className="text-sm text-gray-500">โทรศัพท์</div>
                        <div className="font-medium">045-564-362-2</div>
                      </div>
                    </a>
                    <a
                      href="mailto:lifelong@sskru.ac.th"
                      className="flex items-center gap-2 p-2 hover:bg-gray-50 rounded-lg transition-colors"
                    >
                      <div className="w-8 h-8 bg-blue-100 rounded-full flex items-center justify-center text-blue-600">
                        <i className="fas fa-envelope"></i>
                      </div>
                      <div>
                        <div className="text-sm text-gray-500">อีเมล์</div>
                        <div className="font-medium">lifelong@sskru.ac.th</div>
                      </div>
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ContactPage;
